<template>
  <div class="light-gray">
    <component :is="header" ref="ManagementHeader"></component>
    <slot></slot>
    <component :is="commonModal"></component>
    <component :is="footer"></component>
  </div>
</template>
<script>
import ManagementHeader from '@/components/ManagementHeader.vue'
import ManagementFooter from '@/components/ManagementFooter.vue'
import DeliveryImageSpHeader from '@/components/DeliveryImageSpHeader.vue'
import DeliveryEvaluationHeader from '@/components/DeliveryEvaluationHeader.vue'
import DeliveryEvaluationFooter from '@/components/DeliveryEvaluationFooter.vue'
import CommonModal from '@/components/CommonModal.vue'

export default {
  name: 'CommonLayout',
  props: ['header', 'footer', 'commonModal'],
  components: {
    ManagementHeader,
    ManagementFooter,
    DeliveryImageSpHeader,
    DeliveryEvaluationHeader,
    DeliveryEvaluationFooter,
    CommonModal
  },
  data () {
    return {}
  },
  methods: {
    logout () {
      this.$refs.ManagementHeader.logout()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layout/CommonLayout.vue